var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVk(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 6.01021H5.10839C5.22378 11.8493 7.86713 14.3197 9.96504 14.8301V6.01021H13.3531V11.0428C15.4196 10.8285 17.6014 8.53163 18.3357 6H21.7133C21.4377 7.31042 20.8875 8.55148 20.097 9.6457C19.3065 10.7399 18.2927 11.6638 17.1189 12.3597C18.4291 12.9941 19.5861 13.8916 20.5137 14.9932C21.4413 16.0947 22.1183 17.3751 22.5 18.75H18.7762C17.979 16.3307 15.986 14.4524 13.3531 14.1972V18.75H12.9336C5.75874 18.75 1.66783 13.9726 1.5 6.01021Z",
    fill: "#5C5A72"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVk);
export default __webpack_public_path__ + "static/media/vk.bd4e1b3d8cc76b637c1983b4226544b3.svg";
export { ForwardRef as ReactComponent };